import axios from 'axios';
import { LogoutInvalidToken, RefreshTokenReload, getCookie, getUserAgent } from '../utils/utils';
import configData from './configData.json';
import { LOGOUT_ERROR, NON_SSO } from '../constants/login-constants';
import { getSendVAPTHeaders } from '../helper/vaptHelper';
import { getClientId, getClientSecret, getExpEndpoint, getHierarchyEndpoint, getMerchandiserEndpoint, getMicroserviceEndpoint } from '../helper/apiConfigHelper';
import { fetchWithRetry } from './fetchWithRetry';

const HTTP_METHODS = Object.freeze({
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    DELETE: 'DELETE'
});

const MicroservicePostFetchUtil = (() => {
    const dataCache = {};

    const defaultConfig = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
    };

    const clientConfigs = {
        "client_id": getClientId(configData.common.vn.countryCode),
        "client_secret": getClientSecret(configData.common.vn.countryCode),
        "countryCode": configData.common.vn.countryCode
    };
    let controller = new AbortController();

    const stringToHex = (str) => {
        let arr = [];
        for (let i = 0; i < str.length; i++) {
            arr[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
        }
        return arr.join('');

    };


    const mainRequest = async (url, method, customerToken, isOfflineApp, flag = '') => {

        const userID = localStorage.getItem("email");
        const userAgent = await getUserAgent();
        let loginType = localStorage.getItem("loginType") || NON_SSO;
        let myHeaders = new Headers();
        const countryCode = customerToken.countryCode;
        myHeaders.append("client_id", getClientId(countryCode));
        myHeaders.append("client_secret", getClientSecret(countryCode));
        myHeaders.append("customerToken", customerToken.customerToken);

        const appendCountryCode = (countryCode) => {
            if (countryCode === "idic") {
                myHeaders.append("countryCode", "id");
                myHeaders.append("BusinessGroup", "ic");
            } else {
                myHeaders.append("countryCode", countryCode);
            }
        };

        if (customerToken?.checkStatus) {
            appendCountryCode(customerToken?.countryCode);
            myHeaders.append("interfaceName", customerToken?.interfaceName);
            myHeaders.append("fileName", customerToken?.fileName);
            myHeaders.append("folderPath", customerToken?.folderName);
        } else if (customerToken?.downloadApi) {
            appendCountryCode(customerToken?.countryCode);
            myHeaders.append("folderPath", customerToken?.folderPath);
        } else {
            if (customerToken.countryCode === "idic") {
                myHeaders.append("countryCode", "id");
                myHeaders.append("BusinessGroup", "ic");
            } else {
                appendCountryCode(customerToken?.countryCode);
            }
        }

        if (getSendVAPTHeaders(customerToken?.countryCode) || flag === 'session') {
            myHeaders.append("X-User-ID", userID);
            myHeaders.append("X-Device-ID", userAgent);
            myHeaders.append("X-Login-Type", loginType);
        }

        let requestOptions = {
            method,
            headers: myHeaders,
            redirect: 'follow'
        };
        let baseURL;
        let retries = 2;

        if (flag === 'expAPI') {
            baseURL = getExpEndpoint(customerToken.countryCode);
        }
        else if (flag === 'imadAPI') {
            retries = 0;
            baseURL = getMerchandiserEndpoint(customerToken.countryCode);
        }
        else if (flag === 'hierarchyAPI') {
            baseURL = getHierarchyEndpoint(customerToken.countryCode);
        }
        else {
            baseURL = getMicroserviceEndpoint(customerToken.countryCode);
        }

        const finalURL = `${baseURL}${url}`;

        const req = new Request(finalURL, requestOptions);
        console.log("req", req);
        return new Promise((resolve, reject) => {
            fetchWithRetry(req, retries, 1000)
                .then(response => {
                    if (response) {
                        if (response.ok && response.status >= 200 && response.status <= 299) {
                            if (isOfflineApp) {
                                return response;
                            } else {
                                return response.json();
                            }
                        }
                        else if (response.status >= 400 && response.status < 500) {
                            return response.json();
                        }
                        else if (response.status >= 500) {
                            return response.json();
                        }
                        else {
                            console.log(response)
                            throw new Error(response);
                        }
                    }
                })
                .then((data) => {
                    if ((data.statusCode >= 500 && data?.errors?.errorPayload?.error?.message === "INVALID_ID_TOKEN")
                        || data.status === 407
                    ) {
                        const refreshToken = getCookie("refreshToken");
                        if (refreshToken) {
                            RefreshTokenReload(refreshToken);
                        } else {
                            LogoutInvalidToken();
                        }
                    } else if (data.statusCode === 404 && data?.errors?.errorMessage === LOGOUT_ERROR) {
                        LogoutInvalidToken();
                    }
                    dataCache[stringToHex(req)] = data;
                    resolve(data);
                }, (error) => {
                    reject(new Error(error));
                });
        });
    }

    const postRequest = async (url, method, customerToken, formData, onDownloadProgress, flag = '') => {
        const userID = localStorage.getItem("email");
        const userAgent = await getUserAgent();
        let loginType = localStorage.getItem("loginType") ?? NON_SSO;
        let myHeaders = new Headers();
        let retries = 2;
        const countryCode = customerToken.countryCode;
        myHeaders.append("client_id", getClientId(countryCode));
        myHeaders.append("client_secret", getClientSecret(countryCode));
        myHeaders.append("customerToken", customerToken.customerToken);
        myHeaders.append("interfaceName", customerToken.interfaceName);
        if (customerToken.interfaceName === "uploadOutlet" && countryCode !== "id") {
            myHeaders.append("isDeltaLoad", customerToken.isDeltaLoad);
            myHeaders.append("isFinalUpload", customerToken.isFinalUpload)
        }
        if (customerToken.countryCode === "idic") {
            myHeaders.append("countryCode", "id");
            myHeaders.append("BusinessGroup", "ic");
        } else {
            myHeaders.append("countryCode", customerToken.countryCode);
        }

        if (getSendVAPTHeaders(customerToken?.countryCode)) {
            myHeaders.append("X-User-ID", userID);
            myHeaders.append("X-Device-ID", userAgent);
            myHeaders.append("X-Login-Type", loginType);
        }

       let requestOptions = onDownloadProgress
            ? {
                method,
                headers: myHeaders,
                data: formData,
                onDownloadProgress,
            }
            : {
                method,
                headers: myHeaders,
                body: formData,
                redirect: 'follow'
            };
        let baseURL;
        if (customerToken.isUpdate !== undefined) {
            myHeaders.append("isUpdate", customerToken.isUpdate);
        }

        if (flag === 'expAPI') {
            baseURL = getExpEndpoint(customerToken.countryCode);
        } else if (flag === 'merchAPI') {
            retries = 0;
            baseURL = getMicroserviceEndpoint(customerToken.countryCode);
        }
        else if (flag === "imadAPI") {
            retries = 0;
            baseURL = getMerchandiserEndpoint(customerToken.countryCode);
        }
        else {
            baseURL = getMicroserviceEndpoint(customerToken.countryCode);
        }

        const finalURL = `${baseURL}${url}`;
        const req = new Request(finalURL, requestOptions);
        return onDownloadProgress
            ? axios(finalURL, requestOptions, onDownloadProgress)
                .then(response => {
                    if (response) {
                        if (response.status >= 200 && response.status <= 299) {
                            return response;
                        }
                        else if (response.status >= 400 && response.status < 500) {
                            return response;
                        }
                        else if (response.status >= 500) {
                            return response;
                        }
                        else {
                            console.log(response)
                            throw new Error(response);
                        }
                    }
                })
                .then((data) => {
                    if ((data.statusCode >= 500 && data?.errors?.errorPayload?.error?.message === "INVALID_ID_TOKEN")
                        || data.status === 407
                    ) {
                        const refreshToken = getCookie("refreshToken");
                        if (refreshToken) {
                            RefreshTokenReload(refreshToken);
                        } else {
                            LogoutInvalidToken();
                        }
                    } else if (data.statusCode === 404 && data?.errors?.errorMessage === LOGOUT_ERROR) {
                        LogoutInvalidToken();
                    }
                    dataCache[stringToHex(req)] = data;
                    return data["data"];
                })
            : new Promise((resolve, reject) => {
                fetchWithRetry(req, retries, 1000)
                    .then(async (response) => {
                        if (response) {
                            if (response.ok && response.status >= 200 && response.status <= 299) {
                                return response.json();
                            }
                            else if (response.status >= 400 && response.status < 500) {
                                return response.json();
                            }
                            else if (response.status >= 500) {
                                return response.json();
                            }
                            else {
                                const result = await response.json();
                                throw result;
                            }
                        }
                    })
                    .then((data) => {
                        if ((data.statusCode >= 500 && data?.errors?.errorPayload?.error?.message === "INVALID_ID_TOKEN")
                            || data.status === 407
                        ) {
                            const refreshToken = getCookie("refreshToken");
                            if (refreshToken) {
                                RefreshTokenReload(refreshToken);
                            } else {
                                LogoutInvalidToken();
                            }
                        } else if (data.statusCode === 404 && data?.errors?.errorMessage === LOGOUT_ERROR) {
                            LogoutInvalidToken();
                        }
                        dataCache[stringToHex(req)] = data;
                        resolve(data);
                    }, (error) => {
                        reject(error);
                    });
            });
    }

    const request = async (url, method, headerConfig, body, onUploadProgress) => {
        const userID = localStorage.getItem("email");
        const userAgent = await getUserAgent();
        let loginType = localStorage.getItem("loginType");
        let countryCodeUrl = headerConfig?.countryCode;

        if (headerConfig?.countryCode === "idic") {
            headerConfig.countryCode = "id";
            headerConfig.businessgroup = "ic";
        }
        const configs = {
            "client_id": getClientId(countryCodeUrl),
            "client_secret": getClientSecret(countryCodeUrl),
            "countryCode": countryCodeUrl
        };

        const vAPTHeaderConfig = {
            "X-User-ID": userID,
            "X-Device-ID": userAgent,
            "X-Login-Type": loginType,
        };

        const headers = {
            ...defaultConfig,
            ...countryCodeUrl ? configs : clientConfigs,
            //   "action":actionType,
            ...headerConfig,
            ...(getSendVAPTHeaders(headerConfig.countryCode) ? vAPTHeaderConfig : {})
        };
        const requestConfig = {
            method,
            headers,
            body,
            signal: controller.signal,
        };
        console.log(headers, requestConfig)
        if (method === HTTP_METHODS.POST || method === HTTP_METHODS.PUT) {
            requestConfig.body = JSON.stringify(body)
        }
        const finalURL = `${getMicroserviceEndpoint(countryCodeUrl)}${url} `
        const req = new Request(finalURL, requestConfig);
        return new Promise((resolve, reject) => {
            if (onUploadProgress) {
                axios({
                    url: finalURL,
                    method,
                    headers,
                    data: body,
                    onUploadProgress: (progressEvent) => {
                        onUploadProgress(progressEvent);
                    },
                }).then(response => {
                    if (response.status >= 200 && response.status <= 299) {
                        resolve(response.data);
                    } else {
                        reject(new Error(response));
                    }
                }).catch(error => {
                    reject(new Error(error));
                });
            } else {
                fetchWithRetry(req, 2, 1000)
                    .then(response => {
                        if (response) {
                            if (response.ok && response.status >= 200 && response.status <= 299) {
                                return response.json();
                            }
                            else if (response.status >= 400 && response.status < 500) {
                                return response.json();
                            }
                            else if (response.status >= 500) {
                                return response.json();
                            }
                            else {
                                console.log(response)
                                throw new Error(response);
                            }
                        }
                    })
                    .then((data) => {
                        if ((data.statusCode >= 500 && data?.errors?.errorPayload?.error?.message === "INVALID_ID_TOKEN")
                            || data.status === 407
                        ) {
                            const refreshToken = getCookie("refreshToken");
                            if (refreshToken) {
                                RefreshTokenReload(refreshToken);
                            } else {
                                LogoutInvalidToken();
                            }
                        } else if (data.statusCode === 404 && data?.errors?.errorMessage === LOGOUT_ERROR) {
                            LogoutInvalidToken();
                        }
                        dataCache[stringToHex(req)] = data;
                        resolve(data);
                    }, (error) => {
                        reject(new Error(error));
                    });
            }
        });
    };

    const abort = () => controller.abort();

    return {
        post: (url, customerToken, formData, flag, onDownloadProgress) => {
            return postRequest(url, HTTP_METHODS.POST, customerToken, formData, onDownloadProgress, flag);
        },
        get: (url, customerToken, flag, isOfflineApp) => {
            return mainRequest(url, HTTP_METHODS.GET, customerToken, isOfflineApp, flag);
        },
        put: (url, body, headerConfig = {}, onUploadProgress) => {
            return request(url, HTTP_METHODS.PUT, headerConfig, body, onUploadProgress);
        },
        delete: (url, headerConfig = {}) => {
            return request(url, HTTP_METHODS.DELETE, headerConfig);
        },
        abort: () => {
            abort();
            controller = new AbortController();
        }
    }
})();

export default MicroservicePostFetchUtil;